export function getSearches ({ state, commit }, { search, datefrom, dateto, group_result, page = 1 }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/searches', { params: { search, datefrom, dateto, group_result, page: page } })
      .then((response) => {
        if (response.data.searches) {
          commit('setSearches', response.data.searches)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getIPOrders ({ state, commit }, { ips }) {
  return new Promise((resolve, reject) => {
    if (ips) {
      axiosInstance.post('/v1/searches/ip_orders', { ips })
        .then((response) => {
          if (response.data.ips) {
            commit('setIpsOrders', { ips: response.data.ips })
          }
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('Lipsa ip-uri'))
    }
  })
}

export function deleteSearch ({ state, commit }, searchId) {
  return new Promise((resolve, reject) => {
    if (searchId) {
      axiosInstance.delete('/v1/searches/' + searchId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No search id'))
    }
  })
}
